import { Link } from 'react-router-dom';
import Image from '../image/landing-image.svg'

const LandingPage = () => {
    return ( 
        
        <div className= 'landing-page'>

            {/* <NavBar/> */}
            {/* <hr/> */}

           
            <div className = 'hero-area'>
                
                <img src= {Image}></img>

                <div className='hero-content'>
                <h1 className='main-header'>Explore <font style={{color: 'rgb(47,136,233)'}}>Books</font> by reading<font style={{color: 'rgb(47,136,233)'}}> Quotes</font></h1>

                    <div className='hero-buttons'>
                        <Link to='/browse'><div><span>Browse Glimbay!</span></div></Link>
                        <Link to='/random-book'><div><span>Find Random Book</span></div></Link>
                    </div>
                </div>
            </div>

        </div>

     );
}
 
export default LandingPage;